import { gql } from '__generated__';

export default gql(`
  mutation AddTicket($input: AddTicketInput!) {
    addTicket(input: $input) {
      id
    }
  }
`);
